export enum CommunicationChannelType {
    EMAIL = "email",
    SMS = "sms",
}
